import { render, staticRenderFns } from "./problem.vue?vue&type=template&id=56cfa652&scoped=true&"
import script from "./problem.vue?vue&type=script&lang=js&"
export * from "./problem.vue?vue&type=script&lang=js&"
import style0 from "./problem.vue?vue&type=style&index=0&id=56cfa652&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cfa652",
  null
  
)

export default component.exports